// Footer bar in JInspector — cancel and save buttons.
// Props:
//   isDirty  — controls save button enabled state
//   onSave   — fn() called on save click
//   onCancel — fn() called on cancel click
export default function JInspectorFooter({ isDirty, onSave, onCancel }) {
    return (
        <div className="j-inspector-footer">
            <button className="j-inspector-btn j-inspector-cancel" onClick={onCancel}>
                Cancel
            </button>
            <button className={`j-inspector-btn j-inspector-save${isDirty ? ' dirty' : ''}`} onClick={onSave} disabled={!isDirty}>
                Save
            </button>
        </div>
    );
}
